module.exports = __webpack_public_path__ + "img/step1-3.4d690dd3.png";